

const initializeIndex = () => {
  window.addEventListener('resize', handleWindowResize)
  handleWindowResize()
  const indexHero = document.querySelector('.index-hero')
  indexHero.classList.add('show')
}


const handleWindowResize = () => {
  const ww = window.innerWidth
  const wh = window.innerHeight
  const indexHero = document.querySelector('.index-hero')
  if ((wh - 56) / ww > 0.75) {
    if (!indexHero.classList.contains('m')) {
      indexHero.classList.add('m')
    }
  } else {
    if (indexHero.classList.contains('m')) {
      indexHero.classList.remove('m')
    }
  }
}


const indexMain = () => {
  if (location.pathname == '/') {
    document.addEventListener("DOMContentLoaded", () => {
      initializeIndex()
    })
  }
}

indexMain()
